<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" persistent max-width="900">
      <template v-slot:activator="{ on }">
        <v-btn color="secondary" v-on="on" small>Edit</v-btn>
      </template>
      <v-card>
        <v-title>Edit Address</v-title>
        <br />
        <ValidationObserver ref="observer" v-slot="{ invalid }">
          <v-progress-linear
            :indeterminate="true"
            v-show="isLoading"
            color="primary"
          ></v-progress-linear>
          <v-card-text>
            <v-layout row wrap>
              <v-title>Delivery Address</v-title>
              <v-flex xs12>
                <v-layout ma-0 pa-0 row wrap>
                  <v-flex sm6 md6 lg6>
                    <ValidationProvider
                      name="streetAddress"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        label="Street Address"
                        type="text"
                        v-model="streetAddress"
                        :error-messages="errors"
                        hide-details
                      ></v-text-field>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex sm6 md6 lg6>
                    <ValidationProvider
                      name="suburb"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        label="Suburb"
                        type="text"
                        v-model="suburb"
                        :error-messages="errors"
                        hide-details
                      ></v-text-field>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex sm5 md5 lg5>
                    <ValidationProvider
                      name="state"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        label="State"
                        v-model="state"
                        :error-messages="errors"
                        hide-details
                      ></v-text-field>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex sm5 md5 lg5>
                    <ValidationProvider
                      name="postCode"
                      rules="required|numeric"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        label="Postcode"
                        type="text"
                        v-model="postCode"
                        :error-messages="errors"
                        hide-details
                      ></v-text-field>
                    </ValidationProvider>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <br />
            <v-layout row wrap>
              <v-title>Delivery Contact</v-title>
              <v-flex xs12>
                <v-layout ma-0 pa-0 row wrap>
                  <v-flex class="pt-2">
                    <ValidationProvider
                      name="contactName"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        v-model="contactName"
                        label="Name"
                        :error-messages="errors"
                        @change="resetSelectedContact"
                        hide-details
                      />
                    </ValidationProvider>
                  </v-flex>
                  <v-flex class="pt-2">
                    <ValidationProvider
                      name="contactMobile"
                      rules="required|mobilenumber"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        v-model="contactMobile"
                        label="Mobile:"
                        hide-details
                        @change="resetSelectedContact"
                        name="contactMobile"
                        :error-messages="errors"
                      />
                    </ValidationProvider>
                  </v-flex>
                  <v-flex class="pt-2">
                    <ValidationProvider
                      name="contactEmail"
                      rules="required|email"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        v-model="contactEmail"
                        label="Email:"
                        hide-details
                        @change="resetSelectedContact"
                        name="contactEmail"
                        :error-messages="errors"
                      />
                    </ValidationProvider>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <ValidationProvider
                  name="companyName"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="companyName"
                    label="Company Name:"
                    hide-details
                    :rule="'required'"
                    name="companyName"
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  name="deliveryInstuctions"
                  label="Delivery Instructions"
                  multi-line
                  v-model="deliveryInstructions"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="invalid || isLoading"
              @click="updateDeliveryDetails"
              color="primary"
            >
              Save Delivery Information
            </v-btn>
            <v-btn
              color="primary"
              @click="dialog = false"
              :disabled="isLoading"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </ValidationObserver>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapOrderActions } = createNamespacedHelpers(`orders`);
const { mapActions: mapHardwareActions } =
  createNamespacedHelpers(`orders/hardware`);
const { mapActions: mapCompanyActions } =
  createNamespacedHelpers(`orders/company`);
import { mapGetters } from 'vuex';
const { mapActions: mapAddressActions } =
  createNamespacedHelpers(`orders/address`);
function initialState(data = {}) {
  return {
    dialog: false,
    deliveryInstructions: '',
    contactEmail: null,
    contactMobile: null,
    contactName: null,
    contactID: null,
    showModal: false,
    streetAddress: null,
    suburb: null,
    state: null,
    postCode: null,
    address: null,
    fullAddress: null,
    contacts: [],
    contact: null,
    isNewContact: false,
    isLoading: false,
    companyName: null,
    ...data,
  };
}
export default {
  name: 'edit-address',
  computed: {
    ...mapGetters('orders', ['selectedOrder', 'deliveryDetails']),
  },
  data() {
    return initialState();
  },
  watch: {
    contacts: function (val) {
      return val;
    },
    dialog: function (val) {
      let vm = this;

      if (!val) {
        vm.reset();
        this.$refs.observer.reset();
      } else {
        let {
          deliveryInstructions,
          contactDetails: {
            contactMobile,
            contactName,
            contactID,
            contactEmail,
            companyName,
          },
          addressDetails: { streetAddress, suburb, state, postCode },
          company,
        } = vm.deliveryDetails;
        vm.reset({
          ...vm.$data,
          streetAddress,
          suburb,
          state,
          postCode,
          contactEmail,
          contactMobile,
          contactName,
          contactID,
          deliveryInstructions,
          companyName: companyName
            ? companyName
            : company
            ? company.companyName
            : '',
        });
        this.$refs.observer.reset();
      }
      return this.dialog;
    },
  },
  mounted() {
    let vm = this;

    if (Object.keys(vm.deliveryDetails).length > 0) {
      let {
        addressDetails: { streetAddress, suburb, state, postCode },
        contactDetails: {
          contactEmail,
          contactMobile,
          contactName,
          contactID,
          companyName,
        },
        company,
      } = vm.deliveryDetails;
      vm.streetAddress = streetAddress;
      vm.suburb = suburb;
      vm.state = state;
      vm.postCode = postCode;

      vm.contactEmail = contactEmail;
      vm.contactMobile = contactMobile;
      vm.contactName = contactName;
      vm.contactID = contactID;
      vm.companyName = companyName
        ? companyName
        : company
        ? company.companyName
        : '';
    }
  },
  methods: {
    ...mapHardwareActions(['saveHardware']),
    ...mapOrderActions(['getContacts', 'setMessage', 'getDeliveryDetails']),
    ...mapAddressActions(['updateAddressToCust']),
    ...mapCompanyActions(['updateCompany']),

    resetSelectedContact() {
      this.isNewContact = true;
    },
    reset(data = {}) {
      Object.assign(this.$data, initialState(data));
    },
    updateDeliveryDetails() {
      let vm = this;
      vm.$refs.observer.validate().then((result) => {
        if (result) {
          vm.isLoading = true;
          let {
            streetAddress,
            suburb,
            state,
            postCode,
            deliveryInstructions,
            contactEmail,
            contactMobile,
            contactName,
            contactID,
            companyName,
          } = vm;
          let {
            addressDetails: { customerID, addressID },
            hardwareOrder,
          } = vm.deliveryDetails;
          let updated_address = {
            addressID,
            streetAddress,
            suburb,
            state,
            postCode,
          };
          vm.updateAddressToCust({
            custID: customerID,
            address: updated_address,
          }).then(() => {
            vm.isLoading = true;
            let updated_order = {
              ...hardwareOrder,
              ...updated_address,
              contactEmail,
              contactMobile,
              contactName,
              contactID,
              deliveryInstructions,
              companyName,
            };
            vm.saveHardware({
              orderID: vm.selectedOrder.orderID,
              hardwareOrder: updated_order,
            }).then((res) => {
              vm.isLoading = true;
              vm.getDeliveryDetails(vm.selectedOrder.orderID).then((res) => {
                vm.isLoading = false;
                vm.dialog = false;
              });
            });
          });
        } else {
          vm.isLoading = false;
          vm.dialog = false;
          vm.setMessage({
            message: 'Delivery Information missing',
            httpStatus: 500,
          });
        }
      });
    },
  },
};
</script>
